import ReturnFlight from "../components/Flight/ReturnFlight"
import ReturnFlightResult from "../components/Return/ReturnFlightResult"
import DefaultTemplate from "./DefaultTemplate"


const FlightList = (props) => {
    return (

        <DefaultTemplate>

            <ReturnFlightResult />

        </DefaultTemplate>
    )
}

export default FlightList